import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
  name: "common",
  namespaced: true,
})
export default class Common extends VuexModule {
  contacts = {
    phones: ["8 (800) 550-44-46"],
    mode: "Пн: 9:00-18:00, пер. 13:00-14:00 <br> Сб: 9:00-14:00, без перерыва",
    address: 'Г. Курск, пр. Кулакова 107 "А"',
    addressPhys: 'Г. Курск, пр. Кулакова 107 "А"',
    ogrn: "318312300010966",
    inn: "311401405459",
  };
  interactive = 0;
  onBoarding = false;
  showPassModal = true;
  hidePrice = false;

  get getContacts() {
    return this.contacts;
  }
  get getOnBoarding() {
    return this.onBoarding;
  }
  get getInteractive() {
    return this.interactive;
  }
  get getHidePrice() {
    return this.hidePrice;
  }

  @Mutation
  SET_INTERACTIVE() {
    this.interactive++;
  }

  @Mutation
  SET_CONTACTS(data: any) {
    this.contacts = data;
  }

  @Mutation
  SET_ONBOARDING(data: boolean) {
    this.onBoarding = data;
  }

  @Mutation
  SET_PASS_MODAL(data: boolean) {
    this.showPassModal = data;
  }

  @Mutation
  SET_HIDE_PRICE(data: boolean) {
    this.hidePrice = data;
    localStorage.setItem("hidePrice", JSON.stringify(data));
  }

  @Action
  getResetState(code: string): void {}

  @Action
  resetPassModal(reset: boolean): void {
    this.SET_PASS_MODAL(!reset);
  }
}
